/**
 * Renewal Portal helpers.
 *
 * Mirror of the backend Prestige.BenefitsOE.Shared.Helper.RenewalEligibility constants.
 * The backend is the source of truth: it populates isNewBusinessRenewal and
 * renewalHandlingMode on each ClientOEStatusModel row. These helpers exist so the UI
 * can render badges and gate flows without scattering string literals.
 */

export const RENEWAL_HANDLING_MODE = {
  PORTAL: "Portal",
  MANUAL: "Manual",
};

export const RENEWAL_BADGE = {
  PORTAL: {
    text: "Renewal",
    title: "Eligible for Renewal Portal processing.",
    themeColor: "info",
  },
  MANUAL: {
    text: "Manual Handling",
    title:
      "Renewal not completed by 10/1 cutoff. Routed to manual handling.",
    themeColor: "warning",
  },
};

/** Renewal filter checkbox options -- the badge labels, since that's what's on screen. */
export const RENEWAL_FILTER_OPTIONS = [RENEWAL_BADGE.PORTAL.text, RENEWAL_BADGE.MANUAL.text];

/**
 * Returns the badge descriptor for a client row, or null if no badge should render.
 *
 * Manual-handling rows render no badge at all (same as a non-renewal row) -- the
 * underlying renewalHandlingMode value/filtering is untouched, this only hides the
 * "Manual Handling" label from dashboard cells.
 * @param {{ isNewBusinessRenewal?: boolean, renewalHandlingMode?: string }} clientRow
 */
export function getRenewalBadge(clientRow) {
  if (!clientRow || !clientRow.isNewBusinessRenewal) {
    return null;
  }
  if (clientRow.renewalHandlingMode === RENEWAL_HANDLING_MODE.MANUAL) {
    return null;
  }
  return RENEWAL_BADGE.PORTAL;
}

/**
 * True if the client should be processed through the Renewal Portal flow rather than
 * the manual second BCIF process.
 */
export function isRenewalPortalEligible(clientRow) {
  return (
    !!clientRow &&
    !!clientRow.isNewBusinessRenewal &&
    clientRow.renewalHandlingMode === RENEWAL_HANDLING_MODE.PORTAL
  );
}
